import React from 'react'
import { Center } from '@chakra-ui/react'
import { ScaleLoader } from 'react-spinners'

function PageLoading() {
  return (
    <Center flex="1 1 100%">
      <ScaleLoader color={'#0095f7'} loading />
    </Center>
  )
}
export default PageLoading
